"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutChangedEvent = void 0;
const Contract = require("@tableau/api-external-contract-js");
const TableauEvent_1 = require("./TableauEvent");
class DashboardLayoutChangedEvent extends TableauEvent_1.TableauEvent {
    constructor(_dashboardLayoutChangeDetails) {
        super(Contract.TableauEventType.DashboardLayoutChanged);
        this._dashboardLayoutChangeDetails = _dashboardLayoutChangeDetails;
    }
    get dashboardLayoutChangeDetails() {
        return this._dashboardLayoutChangeDetails;
    }
}
exports.DashboardLayoutChangedEvent = DashboardLayoutChangedEvent;
//# sourceMappingURL=DashboardLayoutChangedEvent.js.map